export const availablePageTypes = [
  {key: 'standard', label: 'Standard'},
  {key: 'full-page', label: 'Full Page'},
]
